import React from 'react';
import Oval from '../assets/images/Oval.png';
import Oval2 from '../assets/images/Oval2.png';
import Oval3 from '../assets/images/Oval3.png';
import Oval4 from '../assets/images/Oval4.png';
import Highlight from './Highlight';
import Button from './Button';

const Support = () => {
  return (
    <div style={styles.wrapper}>
      <div style={styles.textWrapper}>
        <Highlight width={880} height={550} />
        <div style={styles.textBox}>
          <div style={styles.avatars}>
            <img src={Oval} alt="Avatar 1" style={styles.avatar} />
            <img src={Oval2} alt="Avatar 2" style={styles.avatar2} />
            <img src={Oval3} alt="Avatar 3" style={styles.avatar} />
            <img src={Oval4} alt="Avatar 4" style={styles.avatar2} />
          </div>
          <h3 style={styles.heading}>Stručnost i podrška uz svaku kupovinu</h3>
          <p style={styles.text}>
            Uz Smart Part, ne dobijate samo pristup širokoj ponudi auto delova i guma, već i celokupnu podršku našeg iskusnog tima.
            Našu platformu razvili su stručnjaci sa dubokim poznavanjem tržišta, a pored prodajnog tima, posvećeni tehničari, logističari i korisnička podrška
            rade na tome da svaka porudžbina bude brza i bez greške. Sa Smart Part-om, nabavka delova postaje jednostavna, transparentna i isplativa – bez obzira
            da li ste pojedinac ili profesionalac. Uverite se sami!
          </p>
          <Button
            width={232} 
            height={72} 
            borderColor="yellow" 
            backgroundColor="#d3e205" 
            text="Zatraži deo" 
          />
        </div>
      </div>
    </div>
  );
};

export default Support;

const styles = {
  wrapper: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: 'rgb(23, 23, 24)',
    padding: 40,
    gap: 40,
    flexWrap: 'wrap',
    position: 'relative',
    marginBottom: '100px'

  },
  textWrapper: {
    position: 'relative',
    width: 880,
    height: 550,
    zIndex: 3,
  },
  textBox: {
    position: 'relative',
    backgroundImage: 'linear-gradient(232deg, rgba(153, 153, 153, 0.2) 0%, rgba(255, 255, 255, 0.2) 100%)',
    padding: 20,
    borderRadius: 12,
    width: 880,
    height: 550,
    zIndex: 2,
    backdropFilter: 'blur(6px)',
  },
  avatars: {
    display: 'flex',
    marginBottom: 20,
    zIndex: 2,
    position: 'relative',
    justifyContent: 'center',
  },
  avatar: {
    width: 120,
    height: 120,
    borderRadius: '50%',
    border: '3px solid #2c2c2c',
    objectFit: 'cover',
    zIndex: 2,
    marginLeft: -12,
    marginTop: 0,
  },
  avatar2: {
    width: 120,
    height: 120,
    borderRadius: '50%',
    border: '3px solid #2c2c2c',
    objectFit: 'cover',
    zIndex: 1,
    marginLeft: -12,
    marginTop: 20,
  },
  heading: {
    fontSize: '48px',
    fontWeight: 700,
    backgroundImage: 'linear-gradient(235.42deg, #EEFF00 0%, #B6BB6C 100%)',
    backgroundClip: 'text',
    color: 'transparent',
    marginBottom: 16,
    lineHeight: '48px',
    textAlign: 'center',
  },
  text: {
    fontSize: '18px',
    color: '#ffffff',
    lineHeight: '28px',
    marginBottom: 20,
  },
};
